import { Line, Segment, Segments } from "@react-three/drei";
import { Track } from "../types";
import { Color } from "three";

type TrackLinesProps = {
  lines: [number, number][];
  track: Track;
  confidence: number;
  shouldSkipPoint?: (index: number) => boolean;
  color?: Color | string;
  lineWidth?: number;
  dashed?: boolean;
  type?: "segments" | "lines";
};

export function TrackLines(props: TrackLinesProps) {
  const {
    lines,
    confidence,
    shouldSkipPoint,
    lineWidth,
    dashed,
    track,
    color,
    type = "segments",
  } = props;
  const poseConf = track.pose_conf || [];

  const linesFilter = ([startIndex, endIndex]: [number, number]) => {
    const shouldSkip =
      shouldSkipPoint &&
      (shouldSkipPoint(startIndex) || shouldSkipPoint(endIndex));

    const hasEnoughConfidence =
      (poseConf &&
        poseConf[startIndex] > confidence &&
        poseConf[endIndex] > confidence) ||
      poseConf.length === 0;

    return !shouldSkip && hasEnoughConfidence;
  };

  const getLinePoints = ([startIndex, endIndex]: [number, number]): [
    number,
    number,
    number,
  ][] => [
    [
      track.pose_x[startIndex],
      track.pose_z[startIndex],
      -track.pose_y[startIndex],
    ],
    [track.pose_x[endIndex], track.pose_z[endIndex], -track.pose_y[endIndex]],
  ];

  if (type === "segments") {
    return (
      <Segments
        limit={lines.length}
        lineWidth={lineWidth}
        worldUnits
        dashed={dashed}
        dashScale={dashed ? 10 : undefined}
      >
        {lines.filter(linesFilter).map((line, index) => {
          const points = getLinePoints(line);

          return (
            <Segment
              key={index}
              start={points[0]}
              end={points[1]}
              color={color}
            />
          );
        })}
      </Segments>
    );
  }

  return lines.filter(linesFilter).map((line, index) => {
    const points = getLinePoints(line);

    return (
      <Line
        key={index}
        points={points}
        lineWidth={lineWidth}
        worldUnits
        dashed={dashed}
        dashScale={dashed ? 10 : undefined}
        color={color}
      />
    );
  });
}
